import React, {useState, useContext, useEffect} from 'react';
import './SelectionForm.scss';
import {I18nContext} from '../../contexts/i18nContext';
import {SelectionsContext} from '../../contexts/selectionsContext';
import {Button, TextInput} from '../_common';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import ReplayIcon from '@mui/icons-material/Replay';

const SelectionForm = ({primaryButtonAction, secondaryButtonAction, selection, version}) => {
  const { t } = useContext(I18nContext);
  const {
    addSelectionPending,
    error,
  } = useContext(SelectionsContext);

  const [formValues, setFormValues] = useState({
    name: "",
    options: [{optionId: Date.now().toString(), option: "", deleted: false}]
  });

  useEffect(() => {
    if (!!selection) {
      const newValues = {
        optionId: selection.optionId,
        name: selection.name,
        options: selection.options
      }
      setFormValues(newValues);
    }
  }, [selection]);

  const changeValue = (name, value) => {
    const newValues = {...formValues};
    newValues[name] = value;
    setFormValues(newValues);
  };

  const changeOptionValue = (optionIndex, value) => {
    const newValues = {...formValues};
    newValues.options[optionIndex].option = value;
    setFormValues(newValues);
  };

  const addOption = () => {
    const newValues = {...formValues};
    newValues.options.push({optionId: Date.now().toString(), option: "", deleted: false});
    setFormValues(newValues);
  };

  const deleteOption = optionIndex => {
    const newValues = {...formValues};
    if (!selection) {
      newValues.options.splice(optionIndex, 1);
      setFormValues(newValues);
    } else {
      newValues.options[optionIndex].deleted = true;
      setFormValues(newValues);
    }
  };

  const undeleteOption = optionIndex => {
    const newValues = {...formValues};
    newValues.options[optionIndex].deleted = false;
    setFormValues(newValues);
  };

  const handlePrimaryButtonClick = () => {
    if (!selection) {
      primaryButtonAction(formValues)
    } else {
      primaryButtonAction(formValues, selection.id, version)
    }
  };

  const formHasEmptyFields = () => {
    const emptyOptionInputs = formValues.options.filter(option => !option.option);
    return !formValues.name.length || !!emptyOptionInputs.length;
  };

  return (
    <form className='SelectionForm'>
      <div className='formInputs'>
        <TextInput
          label={t('selection list name')}
          required
          name='name'
          onChange={changeValue}
          value={formValues.name}
        />
        {formValues.options.map((option, index) => (
          <div className='optionInputWrapper' key={index}>
            <TextInput
              label={t('option') + " " + (index + 1)}
              required
              name={index}
              onChange={changeOptionValue}
              value={formValues.options[index].option}
              disabled={formValues.options[index].deleted}
            />
            {formValues.options.length !== 1 && !formValues.options[index].deleted && (
              <div className='deleteOptionButton' onClick={() => deleteOption(index)}>
                <ClearIcon />
              </div>
            )}
            {formValues.options[index].deleted && (
              <div className='deleteOptionButton' onClick={() => undeleteOption(index)}>
                <ReplayIcon />
              </div>
            )}
          </div>
        ))}
        {!!formValues.options.at(-1)?.option && (
          <div className='addOptionButton' onClick={addOption}>
            <AddIcon />
          </div>
        )}
      </div>
      <div className='formButtons'>
        <Button type='secondary' action={secondaryButtonAction} label={t('cancel')} />
        <Button
          type='primary'
          action={handlePrimaryButtonClick}
          label={!selection ? t('add selection') : t('save')}
          margin='left'
          disabled={formHasEmptyFields() || addSelectionPending}
          pending={addSelectionPending}
        />
      </div>
    </form>
  );
};

export default SelectionForm;
